import React, {Fragment} from "react";
import TextInput from "../TextInput";
import classNames from "classnames";
import {hufRound} from "../../../utils/other";
import debounce from "lodash-es/debounce";

export default class CashPayment extends React.Component {

    state = {
        cashback: ""
    };

    constructor(props) {
        super(props);
        this.saveChanges = debounce((name, value, amount, cost, total) => {
            if (value + "" !== "" + amount) {
                value = hufRound(parseFloat(value || "0"));
                const bankcardOptionIndex = (this.props.value || []).findIndex((v) => v.serviceprovider_type === "Bankcard");
                if (bankcardOptionIndex !== -1) {
                    this.props.setFieldValue(String(bankcardOptionIndex) + ".amount", Math.max(0, Math.max(total - value, total - (cost - parseFloat(amount || "0")) - value)));
                }
                this.props.setFieldValue(String(this.props.optionIndex) + ".amount", value);
            }
        }, 300);
    }


    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.option && this.props.total + "" !== "" + prevProps.total) {
            this.setState({cashback: ""});
        }
        const bankcardOptionIndex = (this.props.value || []).findIndex((v) => v.serviceprovider_type === "Bankcard");
        if (this.props.option && this.props.total + "" !== "" + prevProps.total && bankcardOptionIndex === -1) {
            let newValue = Math.max(0, this.props.total - (this.props.cost - this.props.option.amount + this.props.rounding) - (this.props.overpay > 0 ? this.props.overpay : 0));
            newValue = hufRound(parseFloat(newValue || "0"));
            if (newValue + "" !== "" + this.props.option.amount) {
                this.props.setFieldValue(String(this.props.optionIndex) + ".amount", newValue);
            }
        }
    }

    render() {
        const amount = this.props.option.amount;
        const cost = this.props.cost;
        const total = this.props.total;
        return (
            <div className="payment cash-payment">
                <TextInput
                    type="number"
                    name="amount"
                    label="Fizetendő"
                    value={this.props.option.amount}
                    saveChanges={(field, value) => this.saveChanges(field, value, amount, cost, total)}
                />
                <TextInput
                    type="number"
                    label="Fizetve"
                    value={this.state.cashback}
                    saveChanges={(name, cashback) => {
                        this.setState({cashback: cashback || ""});
                    }}
                />
                <TextInput
                    type="number"
                    label="Visszajáró"
                    disabled={true}
                    className={classNames({
                       "error": this.state.cashback ? (this.state.cashback || 0) - (this.props.option.amount || 0) < 0 : false
                    })}
                    value={this.state.cashback ? (this.state.cashback || 0) - (this.props.option.amount || 0) : ""}
                />
            </div>
        );
    }
}